import type { IContainer } from '../../interface/container';
import type { IMediumDto } from '../../model';
import type { IProgressPromise } from '../../interface/promise';
import { injectProgressPromise } from '../../interface/promise';
import type { IMediaManager } from '../../controller/interface';
import mediaDelete from './delete';

function deleteMedia(
    container: IContainer,
): (manager: IMediaManager, media: Array<IMediumDto | string>) => IProgressPromise<void> {
    const promiser = injectProgressPromise(container);

    return (manager: IMediaManager, media: Array<IMediumDto | string>) =>
        mediaDelete(promiser, manager, media);
}

const module = {
    deleteMedia,
};

export default module;
